import React, { PropsWithChildren } from 'react';
import { TopUserResult } from '../ComboBox';
import { useHtmlValidId } from '../../../../../hooks/useHtmlValidId';
import { useSonTranslation } from '../../../../../translation/useSonTranslation';
import Btn, { BtnModifier } from '../../../../molecules/Btn';
import { Icons } from '../../../../atoms/SVG';
import { TooltipPlacement } from '../../../../atoms/Tooltip';
import { FormsComboboxMultiSelectListElement } from '../FormsComboboxMultiSelect/partials/FormsComboboxMultiSelectListElement';
import { FormsComboboxMultiselectSelection } from '../FormsComboboxMultiSelect/partials/FormsComboboxMultiselectSelection';

export type UserWithRolesSelectListItemProps = PropsWithChildren<{
  selectedResult: TopUserResult;
  removeResult: (item: TopUserResult) => void;
  userId: number;
}>;

export function UserWithRolesSelectListItem({
  selectedResult,
  removeResult,
  userId,
  children,
}: UserWithRolesSelectListItemProps) {
  const id = useHtmlValidId();
  const { t } = useSonTranslation('FormsComboBoxMultiSelect');

  return (
    <>
      <FormsComboboxMultiSelectListElement>
        <FormsComboboxMultiselectSelection
          id={`recipient-${id}-${selectedResult.id}`}
          title={selectedResult.profileName}
        >
          {children}
          <Btn
            modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
            svgSpriteId={Icons.DELETE_X_SMALL}
            type="button"
            text={t('resultlist.deleteButtonText', { itemName: selectedResult.profileName })}
            titleText={t('resultlist.deleteButtonTitleText', { itemName: selectedResult.profileName })}
            hiddenText
            tooltipPlacement={TooltipPlacement.TOP}
            onClick={() => {
              removeResult(selectedResult);
            }}
          />
        </FormsComboboxMultiselectSelection>
      </FormsComboboxMultiSelectListElement>
      <input type="hidden" name={`memberships[${userId}].userId`} value={selectedResult.id} />
    </>
  );
}
